"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyLogo = void 0;
var Logo_1 = require("./Logo");
Object.defineProperty(exports, "PropertyLogo", { enumerable: true, get: function () { return Logo_1.PropertyLogo; } });
//# sourceMappingURL=index.js.map